import { useEffect, useState } from "react";
import { compareModeOn } from "./compare";

export function useCompareMode() {
  const [on, setOn] = useState(compareModeOn);
  useEffect(() => {
    const f = () => setOn(compareModeOn());
    window.addEventListener("compare-mode-changed", f); window.addEventListener("compare-changed", f);
    return () => { window.removeEventListener("compare-mode-changed", f); window.removeEventListener("compare-changed", f); };
  }, []);
  return on;
}
